import 'normalize.css'
import '~utils/styles/ibm-plex.css'

import React from 'react'
import { createGlobalStyle } from 'styled-components'
import Provider from 'streamr-client-react'
import JavaScript from 'react-syntax-highlighter/dist/esm/languages/prism/javascript'
import Java from 'react-syntax-highlighter/dist/esm/languages/prism/java'
import { CodeSnippet, NavProvider } from '@streamr/streamr-layout'
import { SANS, MEDIUM } from '@streamr/streamr-layout/styled'
import PageContext from '../contexts/PageContext'
import Head from '~shared/Head'
import MobileNav from '~shared/MobileNav'
import { getNetworkConfig } from '~utils/tracker'
import { Css as AppearCSS } from '~shared/Appear'

CodeSnippet.registerLanguages(JavaScript, Java)

const Globals = createGlobalStyle`
    html,
    body {
        color: #323232;
        font-family: ${SANS};
        font-size: 16px;
        height: 100%;
        width: 100%;
    }

    strong {
        font-weight: ${MEDIUM};
    }

    a,
    a:hover,
    a:visited,
    a:active,
    a:focus {
        color: inherit;
        text-decoration: underline;
    }

    a:hover,
    a:focus {
        text-decoration: none;
    }
`

const { http, ws } = getNetworkConfig().streamr

export default (Component, options = {}) => ({ pageContext }) => {
    const { highlight, streamrClient = false, headComponent = <Head /> } = options

    return (
        <>
            <Globals />
            <AppearCSS />
            <PageContext.Provider value={pageContext}>
                {headComponent}
                <NavProvider highlight={highlight}>
                    <MobileNav />
                    {streamrClient ? (
                        <Provider
                            autoConnect
                            autoDisconnect
                            restUrl={http}
                            url={ws}
                            verifySignatures="never"
                        >
                            <Component />
                        </Provider>
                    ) : (
                        <Component />
                    )}
                </NavProvider>
            </PageContext.Provider>
        </>
    )
}
